import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('chemicalsPage');

    return {
        ADD_PRODUCT: t('addProduct'),
        LIBRARY: t('library'),
        MIXES: t('mixes'),
        NEW_MIX: t('newMix'),
        PAGE_SUBTITLE: t('pageSubtitle'),
        PAGE_TITLE: t('pageTitle'),
        SEARCH_BUTTON: t('searchButton'),
        SEARCH_PLACEHOLDER: t('searchPlaceholder')
    };
};

export default useTranslation;
